import { useEffect } from "react";

export const CRYPTO_COMPLETE_MESSAGE = "equidefi:crypto:back-to-merchant";

/**
 * BVNK renders a "Back to merchant" CTA inside the payment iframe when its flow
 * cannot complete (e.g. a network issue).
 * CTA closes iframe and moves the investor back to the investment
 *
 * The page is served from the investor portal, so it is same-origin with the
 * parent; we post to (and the parent verifies against) our own origin.
 */
const CryptoComplete = () => {
  useEffect(() => {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({ type: CRYPTO_COMPLETE_MESSAGE }, window.location.origin);
    }
  }, []);

  return null;
};

export default CryptoComplete;
